/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import PropTypes from "prop-types";

import TapIntoCCommerceBanner from "app/components/banners/tap-into-ccommerce";
import FeaturesHeader from "app/components/features-header";
import { FeaturesHeroSection } from "app/sections/features/features-hero-section";

const FeatureLayout = ({ children }) => {
  // NOTE: The -126px anchor is used for offsetting the
  // y-scroll upon visiting the page via links in the
  // feature header.
  return (
    <>
      <main className="w-full font-montserrat relative overflow-hidden">
        <FeaturesHeroSection />
        <FeaturesHeader />
        <div>
          <a className="invisible relative top-[-126px] block" id="details" />
          {children}
        </div>
        <div className="zbooni-layout py-10 sm:py-12 lg:py-16">
          <TapIntoCCommerceBanner />
        </div>
      </main>
    </>
  );
};

FeatureLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default FeatureLayout;
